module.exports = __webpack_public_path__ + "img/24f.2632d23f.png";